import { BulkProgrammesFileReducer, BulkProgrammesFileReducerStateWithListObject, BulkProgrammesFileReducerStateWithoutListObject, bulkProgrammesFileType } from "./types";

const OBJECT_WITHOUT_LIST_RESPONSE_INIT_STATE = {
    data: {},
    loading: false,
    error: null
};

const OBJECT_WITH_LIST_RESPONSE_INIT_STATE = {
    data: {
        metadata: {
            totalCount: 0,
            currentPageRecords: 0,
            totalPages: 0,
            links: {
                self: null,
                first: null,
                previous: null,
                next: null,
                last: null
            }
        },
        records: []
    },
    loading: false,
    error: null
};

const UploadBulkProgrammesFileReducer = (state: BulkProgrammesFileReducerStateWithoutListObject = OBJECT_WITHOUT_LIST_RESPONSE_INIT_STATE, action: BulkProgrammesFileReducer) => {
    switch (action.type) {
        case bulkProgrammesFileType.UPLOAD_BULK_PROGRAMMES_FILE: {
            return {
                loading: true,
            };
        }
        case bulkProgrammesFileType.UPLOAD_BULK_PROGRAMMES_FILE_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload.data,
                error: null
            };
        }
        case bulkProgrammesFileType.UPLOAD_BULK_PROGRAMMES_FILE_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload.error,
            };
        }
        case bulkProgrammesFileType.RESET_UPLOAD_BULK_PROGRAMMES_FILE: {
            return {
                data: {},
                loading: false,
                error: null
            };
        }

        default:
            return { ...state };
    }
};

const ListBulkProgrammesFileReducer = (state: BulkProgrammesFileReducerStateWithListObject = OBJECT_WITH_LIST_RESPONSE_INIT_STATE, action: BulkProgrammesFileReducer) => {
    switch (action.type) {
        case bulkProgrammesFileType.FETCH_BULK_PROGRAMMES_FILE: {
            return {
                ...state,
                loading: true
            };
        }
        case bulkProgrammesFileType.FETCH_BULK_PROGRAMMES_FILE_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload.data
            };
        }
        case bulkProgrammesFileType.FETCH_BULK_PROGRAMMES_FILE_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload.error
            };
        }

        case bulkProgrammesFileType.RESET_FETCH_BULK_PROGRAMMES_FILE:
            return {
                ...state,
                data: {
                    metadata: {
                        totalCount: 0,
                        currentPageRecords: 0,
                        totalPages: 0,
                        links: {
                            self: null,
                            first: null,
                            previous: null,
                            next: null,
                            last: null
                        }
                    },
                    records: []
                },
                loading: false,
                error: false
            };
        default:
            return { ...state };
    }
};


const DownloadBulkProgrammesFileReducer = (state: BulkProgrammesFileReducerStateWithoutListObject = OBJECT_WITHOUT_LIST_RESPONSE_INIT_STATE, action: BulkProgrammesFileReducer) => {
    switch (action.type) {
        case bulkProgrammesFileType.BULK_PROGRAMMES_FILE_DOWNLOAD: {
            return {
                loading: true,
            };
        }
        case bulkProgrammesFileType.BULK_PROGRAMMES_FILE_DOWNLOAD_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload.data,
                error: null
            };
        }
        case bulkProgrammesFileType.BULK_PROGRAMMES_FILE_DOWNLOAD_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                data: {}
            };
        }
        case bulkProgrammesFileType.RESET_BULK_PROGRAMMES_FILE_DOWNLOAD: {
            return {
                data: {},
                loading: false,
                error: null
            };
        }
        default:
            return { ...state };
    }
};

const BulkProgrammesFileDetailReducer = (state: BulkProgrammesFileReducerStateWithoutListObject = OBJECT_WITHOUT_LIST_RESPONSE_INIT_STATE, action: BulkProgrammesFileReducer) => {
    switch (action.type) {
        case bulkProgrammesFileType.FETCH_BULK_PROGRAMMES_FILE_DETAIL: {
            return {
                loading: true,
            };
        }
        case bulkProgrammesFileType.FETCH_BULK_PROGRAMMES_FILE_DETAIL_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload.data,
                error: null
            };
        }
        case bulkProgrammesFileType.FETCH_BULK_PROGRAMMES_FILE_DETAIL_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                data: {}
            };
        }
        case bulkProgrammesFileType.RESET_FETCH_BULK_PROGRAMMES_FILE_DETAIL: {
            return {
                data: {},
                loading: false,
                error: null
            };
        }
        default:
            return { ...state };
    }
};

const BulkProgrammesFileVersionReducer = (state: BulkProgrammesFileReducerStateWithListObject = OBJECT_WITH_LIST_RESPONSE_INIT_STATE, action: BulkProgrammesFileReducer) => {
    switch (action.type) {
        case bulkProgrammesFileType.BULK_PROGRAMMES_FILE_VERSION: {
            return {
                loading: true,
            };
        }
        case bulkProgrammesFileType.BULK_PROGRAMMES_FILE_VERSION_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload.data,
                error: null
            };
        }
        case bulkProgrammesFileType.BULK_PROGRAMMES_FILE_VERSION_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                data: {
                    metadata: {
                        totalCount: 0,
                        currentPageRecords: 0,
                        totalPages: 0,
                        links: {
                            self: null,
                            first: null,
                            previous: null,
                            next: null,
                            last: null
                        }
                    },
                    records: []
                }
            };
        }
        case bulkProgrammesFileType.RESET_BULK_PROGRAMMES_FILE_VERSION: {
            return {
                data: {
                    metadata: {
                        totalCount: 0,
                        currentPageRecords: 0,
                        totalPages: 0,
                        links: {
                            self: null,
                            first: null,
                            previous: null,
                            next: null,
                            last: null
                        }
                    },
                    records: []
                },
                loading: false,
                error: null
            };
        }
        default:
            return { ...state };
    }
};

const PublishBulkProgrammesFileReducer = (state: BulkProgrammesFileReducerStateWithoutListObject = OBJECT_WITHOUT_LIST_RESPONSE_INIT_STATE, action: BulkProgrammesFileReducer) => {
    switch (action.type) {
        case bulkProgrammesFileType.PUBLISH_BULK_PROGRAMMES_FILE: {
            return {
                loading: true,
            };
        }
        case bulkProgrammesFileType.PUBLISH_BULK_PROGRAMMES_FILE_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload.data,
                error: null
            };
        }
        case bulkProgrammesFileType.PUBLISH_BULK_PROGRAMMES_FILE_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                data: {}
            };
        }
        case bulkProgrammesFileType.RESET_PUBLISH_BULK_PROGRAMMES_FILE: {
            return {
                data: {},
                loading: false,
                error: null
            };
        }
        default:
            return { ...state };
    }
};

const ApproveBulkProgrammesFileReducer = (state: BulkProgrammesFileReducerStateWithoutListObject = OBJECT_WITHOUT_LIST_RESPONSE_INIT_STATE, action: BulkProgrammesFileReducer) => {
    switch (action.type) {
        case bulkProgrammesFileType.APPROVE_BULK_PROGRAMMES_FILE: {
            return {
                loading: true,
            };
        }
        case bulkProgrammesFileType.APPROVE_BULK_PROGRAMMES_FILE_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload.data,
                error: null
            };
        }
        case bulkProgrammesFileType.APPROVE_BULK_PROGRAMMES_FILE_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                data: {}
            };
        }
        case bulkProgrammesFileType.RESET_APPROVE_BULK_PROGRAMMES_FILE: {
            return {
                data: {},
                loading: false,
                error: null
            };
        }
        default:
            return { ...state };
    }
};

const RejectBulkProgrammesFileReducer = (state: BulkProgrammesFileReducerStateWithoutListObject = OBJECT_WITHOUT_LIST_RESPONSE_INIT_STATE, action: BulkProgrammesFileReducer) => {
    switch (action.type) {
        case bulkProgrammesFileType.REJECT_BULK_PROGRAMMES_FILE: {
            return {
                loading: true,
            };
        }
        case bulkProgrammesFileType.REJECT_BULK_PROGRAMMES_FILE_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload.data,
                error: null
            };
        }
        case bulkProgrammesFileType.REJECT_BULK_PROGRAMMES_FILE_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                data: {}
            };
        }
        case bulkProgrammesFileType.RESET_REJECT_BULK_PROGRAMMES_FILE: {
            return {
                data: {},
                loading: false,
                error: null
            };
        }
        default:
            return { ...state };
    }
};

const ListBulkFileSpecificProgrammesReducer = (state: BulkProgrammesFileReducerStateWithListObject = OBJECT_WITH_LIST_RESPONSE_INIT_STATE, action: BulkProgrammesFileReducer) => {
    switch (action.type) {
        case bulkProgrammesFileType.FETCH_BULK_FILE_SPECIFIC_PROGRAMMES: {
            return {
                ...state,
                loading: true,
            };
        }
        case bulkProgrammesFileType.FETCH_BULK_FILE_SPECIFIC_PROGRAMMES_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload.data,
                error: null
            };
        }
        case bulkProgrammesFileType.FETCH_BULK_FILE_SPECIFIC_PROGRAMMES_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                data: {
                    metadata: {
                        totalCount: 0,
                        currentPageRecords: 0,
                        totalPages: 0,
                        links: {
                            self: null,
                            first: null,
                            previous: null,
                            next: null,
                            last: null
                        }
                    },
                    records: []
                }
            };
        }
        case bulkProgrammesFileType.RESET_FETCH_BULK_FILE_SPECIFIC_PROGRAMMES: {
            return {
                ...state,
                data: {
                    metadata: {
                        totalCount: 0,
                        currentPageRecords: 0,
                        totalPages: 0,
                        links: {
                            self: null,
                            first: null,
                            previous: null,
                            next: null,
                            last: null
                        }
                    },
                    records: []
                },
                loading: false,
                error: null
            };
        }
        default:
            return { ...state };
    }
};

const DeleteBulkProgrammesFileReducer = (state: BulkProgrammesFileReducerStateWithoutListObject = OBJECT_WITHOUT_LIST_RESPONSE_INIT_STATE, action: BulkProgrammesFileReducer) => {
    switch (action.type) {
        case bulkProgrammesFileType.DELETE_BULK_PROGRAMMES_FILE: {
            return {
                loading: true,
            };
        }
        case bulkProgrammesFileType.DELETE_BULK_PROGRAMMES_FILE_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload.data,
                error: null
            };
        }
        case bulkProgrammesFileType.DELETE_BULK_PROGRAMMES_FILE_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                data: {}
            };
        }
        case bulkProgrammesFileType.RESET_DELETE_BULK_PROGRAMMES_FILE: {
            return {
                data: {},
                loading: false,
                error: null
            };
        }
        default:
            return { ...state };
    }
};

export {
    UploadBulkProgrammesFileReducer,
    ListBulkProgrammesFileReducer,
    DownloadBulkProgrammesFileReducer,
    BulkProgrammesFileDetailReducer,
    BulkProgrammesFileVersionReducer,
    PublishBulkProgrammesFileReducer,
    ApproveBulkProgrammesFileReducer,
    RejectBulkProgrammesFileReducer,
    ListBulkFileSpecificProgrammesReducer,
    DeleteBulkProgrammesFileReducer
}